<template>
    <div>
        <p style='font-size:18px;color:#333333;margin-top:20px;'>美菱小家电</p>
        <p style='font-size:18px;color:#333333;margin-top: 10px;' id="xiaodian01">一、厨卫、净水及小家电产品保修政策：</p>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>
            2019年3月15日起购买的，且生产日期为2018年1月1日之后的均可享受以下包修政策；生产日期为2018年1月1日之前的所有产品按原保修政策执行。</div>
        <table v-if="serviceContent.length > 0">
            <tr v-for="(item, index) in serviceContent" :key="index">
                <td v-for="(item2, key) in item" :key="key" style="white-space: pre-line;">
                    <p :class="key === 'other' && item2 !== '特殊说明' ? 'p-left' : 'p-center'">{{ item2 }}</p>
                </td>
            </tr>
        </table>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>
            备注：用于商用（酒店、餐饮、发廊等非家用场合）的整机包修半年；除政府工程总部统一明确保修期外，其他工程按工程合同保修时间为准，无法提供合同的按1年保修。</div>
        <p style='font-size:18px;color:#333333;margin-top: 10px;' id="xiaodian02">
            二、美菱生产日期为2018年1月1日之前或购买日期为2019年3月15日之前所有产品保修政策：整机免费保修一年，主要部件三年。</p>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>主要零部件明细：</div>
        <table>
            <tr>
                <td>序号</td>
                <td>产品品类</td>
                <td>整机保修年限</td>
                <td>主要零部件名称及保修年限</td>
            </tr>
            <tr>
                <td>1</td>
                <td>烟机</td>
                <td rowspan="12">免费保修1年</td>
                <td>终生：电机；一年内：开关和电源板</td>
            </tr>
            <tr>
                <td>2</td>
                <td>电热水器</td>
                <td>2016年5月1日起保8年: 内胆；三年内： 加热管、漏保开关电源线、电脑板</td>
            </tr>
            <tr>
                <td>3</td>
                <td>灶具</td>
                <td>一年内：脉冲点火器</td>
            </tr>
            <tr>
                <td>4</td>
                <td>燃气热水器</td>
                <td>一年内：控制器、显示板、风机、热交换器</td>
            </tr>
            <tr>
                <td>5</td>
                <td>保洁柜</td>
                <td>一年内：电源板</td>
            </tr>
            <tr>
                <td>6</td>
                <td>净水器</td>
                <td>一年内：增压泵（自吸泵）、电脑板</td>
            </tr>
            <tr>
                <td>7</td>
                <td>集成灶</td>
                <td>三年内：电机；一年内：脉冲点火器</td>
            </tr>
            <tr>
                <td>8</td>
                <td>壁挂炉</td>
                <td>三年内：控制器、显示板、风机、水泵、比例阀</td>
            </tr>
            <tr>
                <td>9</td>
                <td>电蒸/烤箱，IH电饭煲</td>
                <td>三年内：定时器、电控板、发热管、能量控制器、功能转换开关、电脑板、风扇电机</td>
            </tr>
            <tr>
                <td>10</td>
                <td>洗碗机</td>
                <td>三年内：电控板、电机、程控器、水泵</td>
            </tr>
            <tr>
                <td>11</td>
                <td>吸尘器，豆浆机，破壁机</td>
                <td>三年内：电机</td>
            </tr>
            <tr>
                <td>12</td>
                <td>其他类厨小电</td>
                <td>一年内：电机、电控板</td>
            </tr>
        </table>
        <p style='font-size:18px;color:#333333;margin-top: 10px;' id="xiaodian03">三、注意事项：</p>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>
            （1）保修期界定：以有效保修凭证的开具日期作为保修期的起始日期；没有有效保修凭证，按产品生产日期顺延90天计算。若既无有效保修凭证也无出厂日期及条码，则按保外处理。</div>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>（2）保修凭证：包含发票、有效收据（盖有销售单位公章）、电商购买订单信息等。</div>
        <p style='font-size:18px;color:#333333;margin-top: 10px;' id="xiaodian04">四、免责条款: </p>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>
            下列情况不属“三包”范围，可实行收费修理：（1）消费者因搬运、使用、维护、保管不当造成损坏的；<br>
            （2）非我公司指定的维修点安装、维修造成损坏的（包括消费者自行安装或拆卸修理的）；<br>
            （3）无保修卡及有效发票或购买证明，且无法证明属于保修期内的；<br>
            （4）发票或保修卡与实物不符或涂改的；<br>
            （5）因不可抗拒的自然灾害造成损坏的（雷电、地震等）；<br>
            （6）超过保修期的；<br>
            （7）使用环境（如电压、湿度、温度、通风条件等）不合产品说明书的表述，造成损坏的。
        </div>
        <p style='font-size:18px;color:#333333;margin-top: 10px;' id="xiaodian05">五、安装辅材收费标准：</p>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>1、电热水器常规环境安装辅材最高限价 200 元，燃气热水器常规环境安装辅材最高限价 300 元。
        </div>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>2、常规环境安装辅材限价包含以下内容：
            (1)常规环境下电热水器有效管路安装范围为3米（进出水管合计为3米），不含混水阀；<br>
            (2)常规环境下燃气热水器有效管路安装范围为3米（进出水管合计为3米）、烟道管加长不超过2米，不含气阀、燃气管。<br>
            (3)限价服务范围仅3米内辅材，不含打穿墙孔、玻璃开孔、打支架、拆吊顶、拆旧机等类似与产品安装无直接关联的工作。<br>
            (4)用户自备辅材按照30元/台收取辅材安装费并承担相应的辅材安全责任，由服务网点销售并安装的辅材由服务网点质保半年。<br>
            (5)安新机拆旧机20-40元，单独拆旧机50-80元。<br>
            (6)非常规安装服务项目收费标准<br>
        </div>
        <table>
            <tr>
                <td>产品</td>
                <td>服务项目</td>
                <td>收费金额</td>
                <td>孔径</td>
                <td>备注</td>
            </tr>
            <tr>
                <td rowspan="4">燃气热水器</td>
                <td rowspan="4">开烟管出烟口</td>
                <td>100元/个</td>
                <td>φ60mm-φ90mm</td>
                <td>普通砖墙或等同的墙体</td>
            </tr>
            <tr>
                <td>150元/个</td>
                <td>φ60mm-φ90mm</td>
                <td>混凝土或等同的墙体</td>
            </tr>
            <tr>
                <td>50元/个</td>
                <td>φ60mm-φ90mm</td>
                <td>单层玻璃或等同单层玻璃的材质</td>
            </tr>
            <tr>
                <td>150元/个</td>
                <td>φ60mm-φ90mm</td>
                <td>中空玻璃或等同中空玻璃的材质</td>
            </tr>
            <tr>
                <td rowspan="2">灶具</td>
                <td rowspan="2">台面开扩孔</td>
                <td>100元/个</td>
                <td>/</td>
                <td>大理石、不锈钢、石英等同的材质</td>
            </tr>
            <tr>
                <td>80元/个</td>
                <td>/</td>
                <td>人造石、木制或等同的材质</td>
            </tr>
            <tr>
                <td rowspan="2">灶具、净水机</td>
                <td rowspan="2">管路、线路进出口</td>
                <td>35元/个</td>
                <td>φ6mm-φ24mm</td>
                <td>大理石、不锈钢、石英等同的材质</td>
            </tr>
            <tr>
                <td>25元/个</td>
                <td>φ6mm-φ24mm</td>
                <td>人造石、木制或等同的材质</td>
            </tr>
            <tr>
                <td rowspan="2">吸油烟机</td>
                <td rowspan="2">开烟管出烟口（公共烟道）</td>
                <td>40元/个</td>
                <td>φ150mm-φ200mm</td>
                <td>无需切割墙砖</td>
            </tr>
            <tr>
                <td>100元/个</td>
                <td>φ150mm-φ200mm</td>
                <td>需切割墙砖</td>
            </tr>
        </table>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>(7)辅材收费标准</div>
        <table v-if="materialContent.length > 0">
            <tr v-for="(item, index) in materialContent" :key="index">
                <td v-for="(item2, index2) in item" :key="index2" style="white-space: pre-wrap;">{{ item2 }}</td>
            </tr>
        </table>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>备注：北上广深在以上基础上浮30%；服务项目在本表未体现的，按当地市场价格执行。</div>
        <p style='font-size:18px;color:#333333;margin-top: 10px;' id="xiaodian06">六 、厨卫家电类保外维修收费指导标准：</p>
        <table>
            <tr>
                <td rowspan="2">产品名称</td>
                <td rowspan="2">单位</td>
                <td colspan="2">维修费（元）</td>
            </tr>
            <tr>
                <td>送修</td>
                <td>上门</td>
            </tr>
        </table>
        <table>
            <tr>
                <td rowspan="2">产品名称</td>
                <td rowspan="2">单位</td>
                <td colspan="2">维修费（元）</td>
            </tr>
            <tr>
                <td>送修</td>
                <td>上门</td>
            </tr>
            <tr>
                <td>储水式电热水器60升以下（含60升）</td>
                <td>台/次</td>
                <td>无</td>
                <td>70</td>
            </tr>
            <tr>
                <td>储水式电热水器61-80升（含80升）</td>
                <td>台/次</td>
                <td>无</td>
                <td>75</td>
            </tr>
            <tr>
                <td>储水式电热水器81-120升（含120升）</td>
                <td>台/次</td>
                <td>无</td>
                <td>80</td>
            </tr>
            <tr>
                <td>储水式电热水器121-200升</td>
                <td>台/次</td>
                <td>无</td>
                <td>100</td>
            </tr>
            <tr>
                <td>储水式电热水器201-300升</td>
                <td>台/次</td>
                <td>无</td>
                <td>100</td>
            </tr>
            <tr>
                <td>燃气热水器15升及以下</td>
                <td>台/次</td>
                <td>60</td>
                <td>90</td>
            </tr>
            <tr>
                <td>燃气热水器16升及以上</td>
                <td>台/次</td>
                <td>70</td>
                <td>100</td>
            </tr>
            <tr>
                <td>即热式电热水器</td>
                <td>台/次</td>
                <td>无</td>
                <td>70</td>
            </tr>
            <tr>
                <td>速热式电热水器</td>
                <td>台/次</td>
                <td>无</td>
                <td>70</td>
            </tr>
            <tr>
                <td>小厨宝</td>
                <td>台/次</td>
                <td>45</td>
                <td>70</td>
            </tr>
            <tr>
                <td>吸油烟机</td>
                <td>台/次</td>
                <td>无</td>
                <td>70</td>
            </tr>
            <tr>
                <td>燃气单灶</td>
                <td>台/次</td>
                <td>30</td>
                <td>55</td>
            </tr>
            <tr>
                <td>燃气双灶</td>
                <td>台/次</td>
                <td>50</td>
                <td>70</td>
            </tr>
            <tr>
                <td>气电灶</td>
                <td>台/次</td>
                <td>50</td>
                <td>70</td>
            </tr>
            <tr>
                <td>消毒柜（保洁柜）电烤箱/电蒸箱/蒸烤箱</td>
                <td>台/次</td>
                <td>50</td>
                <td>70</td>
            </tr>
            <tr>
                <td>净水机/洗碗机/台式、立式、壁挂式管线机</td>
                <td>台/次</td>
                <td>50</td>
                <td>70</td>
            </tr>
            <tr>
                <td>壁挂炉</td>
                <td>台/次</td>
                <td>无</td>
                <td>100</td>
            </tr>
            <tr>
                <td>集成灶</td>
                <td>台/次</td>
                <td>无</td>
                <td>100</td>
            </tr>
            <tr>
                <td>蓄热式电暖器</td>
                <td>台/次</td>
                <td>无</td>
                <td>100</td>
            </tr>
            <tr>
                <td>茶吧机</td>
                <td>台/次</td>
                <td>无</td>
                <td>70</td>
            </tr>
            <tr>
                <td>茶吧机（搬动维修）</td>
                <td>台/次</td>
                <td>无</td>
                <td>90</td>
            </tr>
            <tr>
                <td>集成水槽</td>
                <td>台/次</td>
                <td>无</td>
                <td>100</td>
            </tr>
            <tr>
                <td>中央净水机</td>
                <td>台/次</td>
                <td>无</td>
                <td>100</td>
            </tr>
        </table>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>
            1.上门服务：首次上门单程15公里以内免收路程费；超出15公里以外每公里加收1.5元；茶吧机搬动维修超出15公里以外每公里加收3元。</div>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>
            2.如因用户原因导致的多次上门，按照单程15公里以内收取上门服务费30元，超出部分每公里加收1.5元计算。</div>
        <p style='font-size:18px;color:#333333;margin-top: 10px;' id="xiaodian07">七、拆机、移机统一收费指导标准(元)：</p>
        <table>
            <tr>
                <td>产品名称</td>
                <td>拆机</td>
                <td>安装</td>
                <td>拆机+安装</td>
            </tr>
            <tr>
                <td>储水式电热水器60升以下（含60升）</td>
                <td>50</td>
                <td>50</td>
                <td>100</td>
            </tr>
            <tr>
                <td>储水式电热水器61-80升（含80升）</td>
                <td>60</td>
                <td>60</td>
                <td>120</td>
            </tr>
            <tr>
                <td>储水式电热水器81-120升（含120升）</td>
                <td>80</td>
                <td>70</td>
                <td>150</td>
            </tr>
            <tr>
                <td>燃气热水器15升及以下</td>
                <td>40</td>
                <td>40</td>
                <td>80</td>
            </tr>
            <tr>
                <td>燃气热水器16升及以上</td>
                <td>50</td>
                <td>50</td>
                <td>100</td>
            </tr>
            <tr>
                <td>小厨宝</td>
                <td>30</td>
                <td>40</td>
                <td>70</td>
            </tr>
            <tr>
                <td>吸油烟机</td>
                <td>60</td>
                <td>60</td>
                <td>120</td>
            </tr>
            <tr>
                <td>燃气单灶</td>
                <td>30</td>
                <td>40</td>
                <td>70</td>
            </tr>
            <tr>
                <td>燃气双灶</td>
                <td>30</td>
                <td>40</td>
                <td>70</td>
            </tr>
            <tr>
                <td>气电灶</td>
                <td>30</td>
                <td>40</td>
                <td>70</td>
            </tr>
            <tr>
                <td>消毒柜</td>
                <td>30</td>
                <td>30</td>
                <td>60</td>
            </tr>
            <tr>
                <td>壁挂炉</td>
                <td>110</td>
                <td>160</td>
                <td>270</td>
            </tr>
            <tr>
                <td>集成灶</td>
                <td>80</td>
                <td>80</td>
                <td>160</td>
            </tr>
            <tr>
                <td>嵌入式（电烤箱、电蒸箱）</td>
                <td>30</td>
                <td>30</td>
                <td>60</td>
            </tr>
            <tr>
                <td colspan="4" style="text-align: left;">
                    注:<br>1、二次安装若需更换辅材，则需另外购买;与用户沟通清楚，严格按照辅材收费指导标准收取费用。<br>2、远程费用参照保外里程核算标准收取</td>
            </tr>
        </table>
        <p style='font-size:18px;color:#333333;margin-top: 10px;' id="xiaodian08">八、小电类保外维修指导收费标准：</p>
        <table>
            <tr>
                <td rowspan="2">产品品类</td>
                <td rowspan="2">产品名称</td>
                <td rowspan="2">单位</td>
                <td colspan="2">维修费（元）</td>
            </tr>
            <tr>
                <td>送修（检测）</td>
                <td>送修（维修）</td>
            </tr>
            <tr>
                <td rowspan="3">厨房小电</td>
                <td>电饭煲/IH煲</td>
                <td>台/次</td>
                <td rowspan="6">15</td>
                <td>20/30（智能）</td>
            </tr>
            <tr>
                <td>电磁炉，电压力锅，破壁机，微波炉，电饭锅</td>
                <td>台/次</td>
                <td>30</td>
            </tr>
            <tr>
                <td>电蒸/烤箱，电饼铛，电水壶，养生壶，电炖锅，电蒸锅，多用途锅，料理机，和面机，绞肉机，电热锅，豆浆机，果汁机，磨粉机，电火锅，电烤盘</td>
                <td>台/次</td>
                <td>20</td>
            </tr>
            <tr>
                <td rowspan="3">生活家电</td>
                <td>吸尘器，空气净化器，空调扇/塔扇，挂烫机，除湿机，干衣机，扫地机器人，茶吧机、空调扇、晾衣架，足浴盆，移动空调</td>
                <td>台/次</td>
                <td>30</td>
            </tr>
            <tr>
                <td>电风扇，电暖器、踢脚线取暖器，加湿器，饮水机，净水杯，移动电源、灭蚊灯毛球器</td>
                <td>台/次</td>
                <td>20</td>
            </tr>
            <tr>
                <td>其他小型生活电器</td>
                <td>台/次</td>
                <td>20</td>
            </tr>
        </table>
        <div style='font-size: 14px;color: #999999;line-height: 25px;'>
            备注：厨房小电与生活家电类产品需用户送修/检，不提供上门服务。如果需要上门服务，由用户支付50元/台的上门服务费。</div>
    </div>
</template>

<script>
export default{
    name: "XiaoDianCharge",
    data(){
        return {
            serviceContent:[
            {category:'品类',date1:'整机免费保修年限',date2:'易损件保修年限',name:'易损件名称',other:'特殊说明'},
            {category:'电热水',date1:'8',date2:'1',name:'遥控器、镁棒/铝棒、泄压软管、旋钮',other:'1、内胆漏水，自购买之日起 8 年内免费换机。\n2、易损件保修期内凭购买凭证免费更换。\n3、用于商用机整机保修半年。'},
            {category:'小厨宝',date1:'8',date2:'1',name:'镁棒/铝棒、泄压软管、旋钮',other:'1、内胆漏水:自 2021年9 月1日起购买8年免费换机；2021 年9 月 1日之前购买5 年内免费换机;\n2、易损件保修期内凭购买凭证免费更换。\n3、2019年3月15 日-2021年8 月30 日购买，整机包修 3 年,易损件包修 1年。'},
            {category:'型号为GF****系列电热水器',date1:'3',date2:'1',name:'花洒组件、泄压调温阀',other:'1、易损件保修期内凭购买凭证免费更换。\n2、内胆漏水五年包换。\n3、用于商用整机包修半年'},
            {category:'燃气热水器',date1:'6（其中机械强排系列包修3年）',date2:'/',name:'/',other:'1、2019年3月15 日至 2020 年2 月29 日购买且生产日期是 2018 年以后生产的机器，零冷水、冷凝、变频系列包修 5年，其它系列包修 3 年。\n2、2019 年3 月 15 日前购买的机器按照原标准执行包修政策。\n特殊说明:用于商用(理发店、酒店、餐饮等非家用场合)的机器整机包修半年。\n主要部件:热交换器保修 8 年。'},
            {category:'烟机',date1:'5',date2:'1',name:'油灯、冷光灯、滤网、烟管玻璃制件',other:'1、电机终身保修;(电机超过 5 年只免配件费。\n2、易损件保修期内凭购买凭证免费更换。\n3、用于商用整机包修半年。'},
            {category:'灶具',date1:'3',date2:'1',name:'旋钮、火盖、锅支架、装饰环、玻璃制件',other:'1、嵌入式人工煤气灶整机包修 1 年。\n2、易损件保修期内凭购买凭证免费更换。\n3、用于商用整机包修半年。'},
            {category:'净水器',date1:'3',date2:'1',name:'水龙头、PE管、玻璃制件',other:'1、自购买之日起泵包修 5 年。\n2、滤芯属于耗材不在保修期内。\n3、易损件保修期内凭购买凭证免费更换\n4、用于商用整机包修半年。'},
            {category:'嵌入式（消毒柜/蒸烤箱）',date1:'3',date2:'1',name:'紫外线管、石英发热管、玻璃制件',other:'易损件保修期内凭购买凭证免费更换。'},
            {category:'集成灶',date1:'3',date2:'/',name:'/',other:'1、2020 年3 月1日起购买的线上型号，产品整机包修3 年，主要部件:电机、主控板保修 5年。\n2、2020 年3月1日前购买的整机 1年,主要部件 3 年。\n3、用于商用整机包修半年。'},
            {category:'集成水槽',date1:'3',date2:'1',name:'水龙头、连接管、分配器、玻璃制件',other:'易损件保修期内凭购买凭证免费更换。'},
            {category:'茶吧机',date1:'1',date2:'/',name:'/',other:'MY-MC18-1、MY-MC18-3、MY-BCT86 整机、主要零部件保修 2 年。'},
            {category:'嵌入式（洗碗机）/IH电饭煲',date1:'1',date2:'1',name:'玻璃制件',other:'1、主要部件保修三年:电控板、电机、程控器、水泵；定时器、发热管、能量控制器、功能转换开关、风扇电机。\n2、易损件保修期内凭购买凭证免费更换。'},
            {category:'吸尘器/豆浆机/破壁机/等搅拌类产品',date1:'1',date2:'1',name:'玻璃、塑料制品',other:'1、主要部件保修三年: 电机总成、电控组件。\n2、易损件保修期内凭购买凭证免费更换。'},
            {category:'电饭锅/电磁炉/电烤盘/电暖器/等其他类小电产品',date1:'1',date2:'/',name:'/',other:'产品质量问题1年包换。'},
        ],
        materialContent:[
            {index:'序号',name:'辅材名称',unit:'单位',price:'单价（元）'},
            {index:'1',name:'90度弯头',unit:'个',price:'2'},
            {index:'2',name:'塑料管卡',unit:'个',price:'1'},
            {index:'3',name:'内丝直接头（金属内丝）',unit:'个',price:'8'},
            {index:'4',name:'内丝直弯头（金属内丝）',unit:'个',price:'9'},
            {index:'5',name:'外丝三通',unit:'个',price:'12'},
            {index:'6',name:'专用直活接',unit:'个',price:'15'},
            {index:'7',name:'专用弯活接',unit:'个',price:'15'},
            {index:'8',name:'外丝直接头',unit:'个',price:'9'},
            {index:'9',name:'铜角阀',unit:'个',price:'30'},
            {index:'10',name:'外丝弯头',unit:'个',price:'10'},
            {index:'11',name:'内丝三通',unit:'个',price:'10'},
            {index:'12',name:'靠墙内丝弯头',unit:'个',price:'9'},
            {index:'13',name:'加长弯头活接',unit:'个',price:'16'},
            {index:'14',name:'活接三通',unit:'个',price:'16'},
            {index:'15',name:'过桥弯管',unit:'个',price:'4'},
            {index:'16',name:'铜对丝（水）',unit:'个',price:'4'},
            {index:'17',name:'铜球阀（水）',unit:'个',price:'22'},
            {index:'18',name:'铜三通',unit:'个',price:'13'},
            {index:'19',name:'铜弯头',unit:'个',price:'12'},
            {index:'20',name:'铜弯头活接',unit:'个',price:'18'},
            {index:'21',name:'等径直接',unit:'个',price:'1'},
            {index:'22',name:'等径三通',unit:'个',price:'2'},
            {index:'23',name:'PPR截止阀',unit:'个',price:'22'},
            {index:'24',name:'45度弯头',unit:'个',price:'2'},
            {index:'25',name:'PPR管',unit:'米',price:'7'},
            {index:'26',name:'波纹管*20cm',unit:'根',price:'12'},
            {index:'27',name:'波纹管*30cm',unit:'根',price:'15'},
            {index:'28',name:'吊架',unit:'付',price:'130'},
            {index:'29',name:'塑料烟管/2米',unit:'根',price:'55'},
            {index:'30',name:'波纹管*40cm',unit:'根',price:'18'},
            {index:'31',name:'波纹管*50cm',unit:'根',price:'21'},
            {index:'32',name:'波纹管*60cm',unit:'根',price:'24'},
            {index:'33',name:'镁棒',unit:'根',price:'40'},
            {index:'34',name:'生料带',unit:'圈',price:'2'},
            {index:'35',name:'泄流软管',unit:'米',price:'2'},
            {index:'36',name:'异径接头',unit:'个',price:'2'},
            {index:'37',name:'异径三通',unit:'个',price:'3'},
            {index:'38',name:'管帽堵头',unit:'个',price:'1'},
            {index:'39',name:'6分活接（带钢）',unit:'个',price:'30'},
            {index:'40',name:'6分90度弯头',unit:'个',price:'3'},
            {index:'41',name:'6分PPR管',unit:'米',price:'15'},
            {index:'42',name:'铜补芯',unit:'个',price:'8'},
            {index:'43',name:'燃气球阀',unit:'个',price:'35'},
            {index:'44',name:'燃气内牙铜6变4',unit:'个',price:'14'},
            {index:'45',name:'燃气外丝直接',unit:'个',price:'16'},
            {index:'46',name:'燃气内丝直接',unit:'个',price:'16'},
            {index:'47',name:'燃气内丝弯头',unit:'个',price:'18'},
            {index:'48',name:'燃气外丝弯头',unit:'个',price:'18'},
            {index:'49',name:'燃气等径三通',unit:'个',price:'22'},
            {index:'50',name:'燃气内丝三通',unit:'个',price:'22'},
            {index:'51',name:'燃气角阀（两头带牙）',unit:'个',price:'36'},
            {index:'52',name:'烟道弯管',unit:'个',price:'25'},
            {index:'53',name:'直烟管',unit:'个',price:'25'},
            {index:'54',name:'平衡机烟管',unit:'个',price:'60'},
            {index:'55',name:'电热水器支架',unit:'套',price:'120'},
            {index:'56',name:'公共烟道止逆阀',unit:'件',price:'100'},
            {index:'57',name:'铝箔烟管/2米',unit:'根',price:'65'},
            {index:'58',name:'混水阀',unit:'件',price:'80'},
        ]
        }
    },
}
</script>

<style scoped>
 table,
 td {
    font-size: 12px;
     border: 1px solid #ccc;
     color:#333333;
 }

 table {
     margin: 0 auto;
     border-collapse: collapse;
     width: 100%;
 }

 td {
     text-align: center;
     padding: 5px;
     min-width: 20px;
 }

 p{
    font-size:18px;
    color:#333333;
    margin-top:10px;
 }

 .struction{
    width:92%;
    display: inline-block;
    text-align: left;
    /* padding-left: 4%; */
    overflow-y: scroll;
  }
  .p-left{
  font-size: 12px;
  text-align: left; 
  width: 100%;
 }
 .p-center{
  font-size: 12px;
  width: 100%;
 }
</style>


// WEBPACK FOOTER //
// src/components/XiaoDianCharge.vue